import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { Fab, Tooltip } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import SystemParametersListItems from './Components/SystemParametersListItems';
import useAPI from '../../../api';
import SystemParametersDialog from './Components/SystemParametersDialog';
import useNotify from '../../../Hooks/useNotify';

const SystemParametersPage = function SystemParametersPage({ searchedValue }) {
  const intl = useIntl();
  const API = useAPI();
  const { notify, notifyError } = useNotify();
  const [settings, setSettings] = useState(null);
  const [newDialog, setNewDialog] = useState(null);
  const [editDialog, setEditDialog] = useState(null);
  const [dialogId, setDialogId] = useState('');
  const [title, setTitle] = useState('');

  useEffect(() => {
    API.getSettings(
      (res) => {
        setSettings(res);
      },
      () => {
        notify('ERROR_LOADING_SYSTEM_PARAMETER', 'error');
      }
    );
  }, []);

  const openNewSettingsDialog = () => {
    setDialogId('newSetting');
    setNewDialog(true);
  };

  const openEditSettingDialog = (setting) => {
    setDialogId('editSetting');
    setEditDialog(setting);
    setTitle(setting.settingName);
  };

  const closeSettingDialog = () => {
    setEditDialog(null);
    setNewDialog(null);
  };

  const handleNewSettingSubmit = (newSetting) => {
    const settingExists = settings.some(
      (item) => item.settingName === newSetting.settingName
    );

    if (settingExists) {
      notify('EXISTING_SYSTEM_PARAMETER', 'error');
      return;
    }
    API.createSetting(
      newSetting,
      (newData) => {
        notify('NEW_SYSTEM_PARAMETER_CREATE_SUCCESSFULLY', 'success');
        setSettings((prev) => [newData, ...prev]);
        setNewDialog(null);
      },
      (err) => {
        notifyError('CREATE_SYSTEM_PARAMETER_ERROR', err);
      }
    );
  };

  const handleEditSubmit = (editSetting) => {
    API.editSetting(
      editSetting,
      (editData) => {
        notify('SYSTEM_PARAMETER_EDITED_SUCCESSFULLY', 'success');
        setSettings((prev) =>
          prev.map((item) =>
            item.settingName === editData.settingName ? editData : item
          )
        );
        setEditDialog(null);
      },
      (err) => {
        notifyError('EDITING_SYSTEM_PARAMETER_ERROR', err);
      }
    );
  };

  return (
    <div style={{ overflow: 'auto' }}>
      <Tooltip title={intl.messages.NEW_SYSTEM_PARAMETER}>
        <Fab
          color="primary"
          aria-label={intl.messages.NEW_SYSTEM_PARAMETER}
          onClick={openNewSettingsDialog}
          sx={{
            position: 'absolute',
            bottom: 30,
            right: 30,
          }}
        >
          <AddIcon />
        </Fab>
      </Tooltip>
      <SystemParametersListItems
        settings={settings}
        onClick={openEditSettingDialog}
        searchedValue={searchedValue}
      />
      <SystemParametersDialog
        dialogId={dialogId}
        title={intl.messages.NEW_SYSTEM_PARAMETER}
        open={Boolean(newDialog)}
        settings={newDialog}
        existingNames={settings?.map(({ settingName }) => settingName)}
        handleClose={closeSettingDialog}
        onSubmit={handleNewSettingSubmit}
      />
      <SystemParametersDialog
        dialogId={dialogId}
        title={title}
        open={Boolean(editDialog)}
        settings={editDialog}
        handleClose={closeSettingDialog}
        onSubmit={handleEditSubmit}
      />
    </div>
  );
};

export default SystemParametersPage;
